import React, { useEffect } from 'react';
import AuthWrapper from './authWrapper';

const AccessDenied = () => {

  useEffect(() => {
    setTimeout(() => {
      window.location.href = "/";
    }, 10000)
  }, []);
  return (
    <AuthWrapper style={{ width: '100%', height: '100vh' }}>
      <>Please contact sales at <a href="mailto:sales@arpari.com">sales@arpari.com</a> {' '}
        to enable your dashboard. Redirecting momentarily...</>
    </AuthWrapper>
  );
}

export default AccessDenied;